import { cn } from '@/lib/utils';

/**
 * The selection checkbox, a NATIVE `<input type="checkbox">` rather than a Radix primitive.
 *
 * The Brand Kit requires explicit Human approval for a new package, and `@radix-ui/react-checkbox`
 * is not installed. Nothing here needs it: a native checkbox already carries the role, the checked
 * and indeterminate states, the label association, the keyboard model and the form semantics that a
 * custom control would have to re-implement. `accent-color` styles it in the brand's own colour in
 * every browser the platform supports, so the only thing that would be gained by a package is a
 * custom tick glyph.
 *
 * `indeterminate` is not an attribute — it exists only as a DOM PROPERTY — which is why it is set
 * through a ref callback rather than passed through JSX like the others.
 */
export function Checkbox({
  indeterminate = false,
  className,
  ...props
}: Omit<React.ComponentProps<'input'>, 'type'> & { indeterminate?: boolean }) {
  return (
    <input
      type="checkbox"
      ref={(node) => {
        if (node !== null) {
          node.indeterminate = indeterminate;
        }
      }}
      className={cn(
        'accent-primary focus-visible:ring-ring size-4 cursor-pointer align-middle',
        'focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none',
        className,
      )}
      {...props}
    />
  );
}
